$(document).ready(function() {
  var checkTaborIpad = function() {
    if(window.innerHeight > window.innerWidth) {
        console.log("portrait",'window.innerHeight',window.innerHeight,'window.innerWidth',window.innerWidth);
        $('.bodycontainer').css('display','none');
        $('#header').css('display','none');
        $('footer').css('display','none')
        $('.ipadcon').css('display','block');
    } else {
      console.log("landscape",'window.innerHeight',window.innerHeight,'window.innerWidth',window.innerWidth);
      $('.bodycontainer').css('display','block');
      $('#header').css('display','block');
      $('footer').css('display','block')
      $('.ipadcon').css('display','none');

    }

    $(window).on("orientationchange",function() {
      window.setTimeout(function () {
        if(window.innerHeight > window.innerWidth){
            $('.bodycontainer').css('display','none');
            $('#header').css('display','none');
            $('footer').css('display','none')
            $('.ipadcon').css('display','block');
            console.log("portrait",'window.innerHeight',window.innerHeight,'window.innerWidth',window.innerWidth);
        } else {
          $('.bodycontainer').css('display','block');
          $('#header').css('display','block');
          $('.ipadcon').css('display','none');
          $('footer').css('display','block')
          console.log("landscape",'window.innerHeight',window.innerHeight,'window.innerWidth',window.innerWidth);
        }

      },500)
    });
  }
  String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  }
  Array.prototype.zip = function (arr) {
    return this.map(function (e, i) {
        return [e, arr[i]];
    })
  };

  if(((/Android/i.test(navigator.userAgent)) && (!/Mobile/i.test(navigator.userAgent))) || (/iPad/i.test(navigator.userAgent))) {
    $('#app-fixed-footer-m').css('display','none');
    $('#header').removeClass('adf');
    checkTaborIpad();
  }

  function getMonthText(month) {
  switch(month) {
    case 1:
      month = 'Jan';
      break;
    case 2:
      month = 'Feb';
      break;
    case 3:
      month = 'Mar';
      break;
    case 4:
      month = 'Apr';
      break;
    case 5:
      month = 'May';
      break;
    case 6:
      month = 'Jun';
      break;
    case 7:
      month = 'Jul';
      break;
    case 8:
      month = 'Aug';
      break;
    case 9:
      month = 'Sept';
      break;
    case 10:
      month = 'Oct';
      break;
    case 11:
      month = 'Nov';
      break;
    case 12:
      month = 'Dec';
      break;
    }
  }

  if(!localStorage.fCallStack){
    localStorage.fCallStack = ''
  }

  window.changeRoute = function(path){
    location.replace(location.protocol + '//' + location.host+'/' + path);
  }

  localStorage.fCallStack && localStorage.fCallStack.split(',').map(function(x){ x() });

	if (/Android/i.test(navigator.userAgent)) {
         $('.iphone-show').css('display', 'none');
     } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
         $('.android-show').css('display', 'none');
     } else {
     	$('.fb-like').css('display','block')
     }
     if ((!localStorage.getItem('logged_in') || (typeof localStorage.getItem('wedding_id') == 'undefined') || localStorage.getItem('wedding_id') == 'null')  && (!localStorage.getItem('vendor_logged_in'))) {
        $('#l_y_b').css('display', 'block');
    }
    //$('.bodycontainer').css('min-height',winHeight)
    if (document.URL.indexOf('back_from_fb=1') != -1 && document.URL.indexOf('code=') != -1) {
      pollingInterval = setInterval(function() {
        if(typeof FB != "undefined"){
            FB.getLoginStatus(function(response) {
              if (response.status === 'connected') {
                  // Logged into your app and Facebook.
                  var userid = response.authResponse.userID;
                  fbtoken = response.authResponse.accessToken;
                  FB.api('/me', 'get', {
                      access_token: fbtoken,
                      fields: 'id,first_name,last_name,email,gender'
                  }, function(response) {
                      id = response.id;
                      gender = response.gender;
                      first_name = response.first_name;
                      last_name = response.last_name;
                      email = response.email;
                      if (!email || (typeof email == 'undefined') || email == 'null') {
                          $('.reveal-modal').trigger('reveal:close');
                          $('#loginModal').modal('hide');
                          $('#fbModal').modal('show');
                          $('#fbModal').find('.req-error').css('display', 'none');
                          $('#fbModal').find('.email-error').css('display', 'none');
                      } else {
                          fbEmailLogin(fbtoken, email, first_name, last_name, gender, id);
                      }
                  });
              } else if (response.status === 'not_authorized') {
                  // The person is logged into Facebook, but not your app.
              } else {
                  // The person is not logged into Facebook, so we're not sure if
                  // they are logged into this app or not
              }
            }, true);
          }else{
            alert("FB is not responding, Please try again!",function(){return true;});
          }
     } , 1000);
    }
});

function cityOnKeyUp(e){
  console.log(e.value);
	var searchTerm = e.value.toLowerCase();
	$('.vendor-city-ul li').each(function(){
		if ($(this).filter('[data-search-term *= ' + searchTerm + ']').length > 0 || searchTerm.length < 1) {
			$(this).attr('style', 'display: block !important');
		} else {
			$(this).attr('style', 'display: none !important');
		}
	});
}

function categoryOnKeyUp(e){
	console.log(e.value);
	var searchTerm = e.value.toLowerCase();
	$('.vendor-cat-ul li').each(function(){
		if ($(this).filter('[data-search-term *= ' + searchTerm + ']').length > 0 || searchTerm.length < 1) {
			$(this).attr('style', 'display: block !important');
		} else {
			$(this).attr('style', 'display: none !important');
		}
	});
}

function $elInViewport(el) {
  var el = el.get(0);
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top >= window.pageYOffset &&
    left >= window.pageXOffset &&
    (top + height) <= (window.pageYOffset + window.innerHeight) &&
    (left + width) <= (window.pageXOffset + window.innerWidth)
  );
}

$.fn.isOnScreenVertical = function() {
  var viewport = {};
  viewport.top = $(window).scrollTop();
  viewport.bottom = viewport.top + $(window).height();
  var bounds = {};
  bounds.top = this.offset().top;
  bounds.bottom = bounds.top + this.outerHeight();
  // return ((bounds.top <= viewport.bottom) && (bounds.bottom >= viewport.top));
  return ((bounds.bottom >= viewport.top));
};

Array.prototype.getUnique = function(){
   var u = {}, a = [];
   for(var i = 0, l = this.length; i < l; ++i){
      if(u.hasOwnProperty(this[i])) {
         continue;
      }
      a.push(this[i]);
      u[this[i]] = 1;
   }
   return a;
}

/*if (!localStorage.getItem('token') || localStorage.getItem('token') == 'null' || localStorage.getItem('token') == 'undefined') {
    window.signUpPrompt = window.setTimeout(
        function() {
            $('#signupPromptModal').modal('toggle');
        },6500);
}*/
var currentLoctaion = "notDelhi"
var currentLocality = "notDelhi"
var venueAndTransactionNumber = 0;
var currentPlace;
function randomVenueAndTransaction(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}
function getLocation() {
  $.getJSON('//gd.geobytes.com/GetCityDetails?callback=?', function(data) {
    showPosition(data.geobyteslatitude,data.geobyteslongitude);
  });
}
function showPosition(lat,lng) {
  http://localhost:8000/api/v1/stores_latlong?lat=28.4595&long=77.0266&version=1.1&token=5649f33b0cee12.68085519
  $.ajax({
    method:'get',
    url:domain_name + '/api/v1/stores_latlong?lat='+lat+'&long='+lng+'&version=1.1&token='+config.token
  }).done(function(data) {
    currentLoctaion = data.data.id;
  })
}

$('#close-notification').on('click',function() {
	console.log('asdadgsdg');
  sessionStorage.setItem('mua', 'true');
  $('#MUA_sticky').css('display','none');
});

$('.venue-con-close').on('click',function() {
  localStorage.setItem('venueConModal', 'true');
//  $('#Venue_Concierge_sticky').css('display','none');
});
$('.transaction-bride-close').on('click',function() {
  localStorage.setItem('transactionBrideModal', 'true');
  $('#transaction_sticky').css('display','none');
});
$('.mua-close').on('click',function() {
  localStorage.setItem('mua', 'true');
  $('#MUA_sticky').css('display','none');
});

var decrypt = function(encrypted, secret) {
    var decrypted = CryptoJS.TripleDES.decrypt(encrypted, secret);
    var decryptedString = decrypted.toString(CryptoJS.enc.Latin1);
    if (!decryptedString) {
        return null;
    }
    try {
        return JSON.parse(decryptedString);
    } catch (e) {
        return null;
    }
};
var get = function(key) {
    var encrypted = window.localStorage.getItem(key);
    return encrypted && decrypt(encrypted, 'WedMeExcellent');
};
var domain_name = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
var is_loggedin = localStorage.getItem('logged_in');
var token = localStorage.getItem('token');
var vtoken = localStorage.getItem('vtoken');

function getIndexPosition(str, pat, n) {
    var L = str.length,
        i = -1;
    while (n-- && i++ < L) {
        i = str.indexOf(pat, i);
    }
    return i;
}

function isDesktop(){
  if(!(/Android/i.test(navigator.userAgent)) && !(/Mobile/i.test(navigator.userAgent)) && !(/iPad/i.test(navigator.userAgent))){
    return true;
  }else{
    return false;
  }
}

function isSessionValid(){
  if (sessionStorage.getItem('mua')){
    return false;
  }else{
    return true;
  }
}

function showPromoPopUp(){
  var session = isSessionValid();
  $('#MUA_sticky').css('display','block');
  //Restrict Location To Delhi
  /*
  var link = window.location.href;
  var vendor_logged_in = localStorage.getItem('vendor_logged_in');

  $.ajax({
    method:'post',
      url: domain_name+ '/api/v1/check_city_lat_long?version=1.1&token=' + token,
      data: {
          city_id:9
      }
  }).done(function(data){
    var isNearby = data.data.is_nearby;
    // var isNearby = true;
    var session = isSessionValid();
    var desktop = isDesktop();
    if( isNearby && session && desktop){
      $('#MUA_sticky').css('display','block');
    }
    if((link.search('makeup101') != -1) || (link.search('venue-suggestions') != -1) || (link.search('/vendor/feeds') != -1 ) ){
      $('#MUA_sticky').css('display','none');
    }
  });
  */
}

//  showPromoPopUp();

function getUrlVars() {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

var showRegisterPrompt = function() {
    $('#cnaButton').css('display','none');
    $('#registerPromptDiv').css('display','block');
}

var fbEmailLogin = function(fbtoken, email, first_name, last_name, gender, id) {
    $.ajax({
        method: 'get',
        url: "https://graph.facebook.com/v2.5/"+id+"/picture?access_token",
    }).done(function(response, textStatus, XHR) {
        var token = localStorage.getItem('token');
        if (token == null) {
            token = 0;
        }
        if (response && !response.error) {
            var profile_pic = XHR.getResponseHeader('location');
            $.ajax({
                method: 'post',
                url: domain_name + '/api/v1/user/fb_login?version=1.1&token=' + token,
                data: {
                    fb_authtoken: fbtoken,
                    email: email,
                    firstname: first_name,
                    lastname: last_name,
                    gender: gender,
                    fb_id: id,
                    profile_pic_url: XHR.getResponseHeader('location')
                }
            }).done(function(data) {
                if (!data.response.status) {
                    $('#fb_email_error').html('*' + data.response.message);
                } else {
                    $.ajax({
                        method: 'get',
                        url: domain_name + '/api/v1/user/profile?version=1.1&token=' + token
                    }).done(function(data) {
                        console.log('====>', data);
                        if (!localStorage.getItem('wedding_id') || data.response.status) {
                            localStorage.setItem('logged_in', 'true');
                            localStorage.setItem('profile_pic', data.data[0].profile_pic_url);
                            if (localStorage.getItem('redux')) {
                                var redux = JSON.parse(localStorage.getItem('redux'));
                            }
                            else {
                                var redux = { login: {}, profile: {} };
                            }
                            redux['login']['loggedIn'] = true;
                            redux['login']['loginType'] = 'User';
                            redux['profile']['profileType'] = 'User';
                            redux['profile']['myWedding'] = data.data.my_wedding;
                            redux['profile']['profile'] = data.data[0];
                            redux['profile']['userProperties'] = data.data.user_properties;
                            redux['profile']['weddings'] = data.data.weddings;
                            localStorage.setItem('redux', JSON.stringify(redux));

                            if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                                window.location.reload();
                                return;
                            }
                            if (window.location.pathname == '/' && (data.data.my_wedding || data.data.weddings[0].wedding_id)) {
                                window.location.href = domain_name + '/dashboard/profile/feeds/';
                            } else {
                                window.location.reload();
                            }
                        }
                    });
                }
            })
        }
    });
}
var id = 0;
var gender = '';
var first_name = '';
var last_name = '';
var email = '';
var fbtoken = 0;
var continueFbLogin = function() {
    $('#fbModal').find('.req-error').css('display', 'none');
    $('#fbModal').find('.email-error').css('display', 'none');
    var email = $('#fbemail').val();
    if (!email) {
        $('#fbModal').find('.req-error').css('display', 'block');
        return;
    }
    if (!validateEmail(email)) {
        $('#fbModal').find('.email-error').css('display', 'block');
        return;
    }
    fbEmailLogin(fbtoken, email, first_name, last_name, gender, id);
}

var closeVcat = function() {
  $('.v-cat-view').addClass('invisible');
}

var fblogin = function() {
  console.log('facebook');  
  if ( navigator.userAgent.match('CriOS') ) {
    var redirect_uri = document.location.href;
    if(redirect_uri.indexOf('?') !== -1){
            redirect_uri += '&back_from_fb=1';
    } else {
            redirect_uri += '?back_from_fb=1';
    }
    var url = 'https://www.facebook.com/dialog/oauth?client_id=400046146843075&redirect_uri='+redirect_uri+'&scope=email,public_profile';
    var win         =   window.open(url, '_self');
  } else {
    FB.login(function(response) {
        console.log(response);
        if (response.status === 'connected') {
            // Logged into your app and Facebook.
            var userid = response.authResponse.userID;
            fbtoken = response.authResponse.accessToken;
            FB.api('/me', 'get', {
                access_token: fbtoken,
                fields: 'id,first_name,last_name,email,gender'
            }, function(response) {
                id = response.id;
                gender = response.gender;
                first_name = response.first_name;
                last_name = response.last_name;
                email = response.email;
                if (!email || (typeof email == 'undefined') || email == 'null') {
                    $('.reveal-modal').trigger('reveal:close');
                    $('#loginModal').modal('hide');
                    $('#fbModal').modal('show');
                    $('#fbModal').find('.req-error').css('display', 'none');
                    $('#fbModal').find('.email-error').css('display', 'none');
                } else {
                    fbEmailLogin(fbtoken, email, first_name, last_name, gender, id);
                }
            });
        } else if (response.status === 'not_authorized') {
            // The person is logged into Facebook, but not your app.
        } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not
        }
    }, {
        scope: 'public_profile,email',
        return_scopes: true
    });
  }
};

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
var forgotPass = function(e) {
    e.preventDefault();
    var $form = $(e.target).parents('form');
    var token = localStorage.getItem('token');
    if (token == null) {
        token = 0;
    }
    var email = $form.find('#username').val();
    $.ajax({
        method: 'post',
        url: domain_name + "/api/v1/user/forgot_password?version=1.1&token=" + token,
        data: {
            email: email
        }
    }).done(function(data) {
        if (!data.response.status) {
            $form.find('#forgot-error').html('*' + data.response.message);
            return;
        } else {
            var html = $form.html();
            $form.html('<p style="padding: 15px;padding-top: 50px;color: #27AE5F;font-weight: 600;">An email has been sent to your email address. It contains a link you must click to reset your password.</p>');
            window.setTimeout(function() {
                $form.html(html);
                $('#formModal').trigger('reveal:close');
            }, 2500);
        }
    })
}
var selectArray = [];
var catFlag = 0;
var cityFlag = 0;
var cityerrFlag = 0;
var caterrFlag = 0;
var selectedCat = '';
var selectedCity = '';
var selectedName = 0;
var selectedCityName = 0;
var cityArray = [];
// code to get all the categories and display it
var mastersApi = function() {
    var token = localStorage.getItem('token');
    $.ajax({
        method: 'get',
        url: domain_name + '/api/v1/masters?version=1.1&token=' + token,
    }).done(function(data) {
			console.log(data);
        selectArray = data.data.category;
        cityArray = data.data.city;

        for (var i = 0; i < selectArray.length; i++) {
          if(selectArray[i].is_whitelabel != "1" ){
            $('.vendor-cat-ul').append('<li data-search-term="' + selectArray[i].category_alias.toLowerCase() + '" id="cat-' + selectArray[i].id + '" class="category-li" onclick="selectCat(event)">' + selectArray[i].category_alias + '</li>');
          }
        }

        for (var i = 0; i < cityArray.length; i++) {
					console.log('sdg');
          $('.vendor-city-ul').append('<li data-search-term="' + cityArray[i].name.toLowerCase() + '" id="city-' + cityArray[i].id + '" class="city-li" onclick="selectCity(event)">' + cityArray[i].name + '</li>');
        }
    })
};

// code to show, hide categorieso
var showUlCat = function(e) {
        var $this = $(e.target);
        if (!catFlag) {
            $this.parents('#vendor-categories').css('height', 'auto');
            $this.parents('#vendor-categories').find('#categoryInit').css('color', 'rgba(128, 128, 128, 0.631373)');
            $this.parents('#vendor-categories').find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up')
            catFlag = 1;
            $this.closest('.signupidiv').find('#vcatError').css('display', 'none');
        } else {
            $this.parents('#vendor-categories').css('height', '32px');
            $this.parents('#vendor-categories').find('#categoryInit').css('color', '#555');
            $this.parents('#vendor-categories').find('.fa-chevron-up').addClass('fa-chevron-down').removeClass('fa-chevron-up');
            catFlag = 0;
            if (caterrFlag) {
                $this.closest('.signupidiv').find('#vcatError').css('display', 'block');
            }
        }
    }
    // code to select one category and store the value
var selectCat = function(e) {
    var $this = $(e.target);
    selectedCat = $this.attr('id').split('-')[1];
    selectedName = $this.html();
    $this.closest('#vendor-register-form').find('#categoryInit').text(selectedName) //= '';//(selectedName);
    $this.closest('#vendor-register-form').find('#categoryInit').append('<i class="fa svt-arrow fa-chevron-down" style="top: 8px;"></i>');
}

// code to show, hide cities
var showUlCity = function(e) {
     var $this = $(e.target);
     if (!cityFlag) {
         $this.parents('#vendor-cities').css('height', 'auto');
         $this.parents('#vendor-cities').find('#cityInit').css('color', 'rgba(128, 128, 128, 0.631373)');
         $this.parents('#vendor-cities').find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up')
         cityFlag = 1;
         $this.closest('.signupidiv').find('#vcityError').css('display', 'none');

     } else {
         $this.parents('#vendor-cities').css('height', '32px');
         $this.parents('#vendor-cities').find('#cityInit').css('color', '#555');
         $this.parents('#vendor-cities').find('.fa-chevron-up').addClass('fa-chevron-down').removeClass('fa-chevron-up');
         cityFlag = 0;
         if (cityerrFlag) {
             $this.closest('.signupidiv').find('#vcityError').css('display', 'block');
         }
     }
 }
     // code to select one city and store the value
var selectCity = function(e) {
     var $this = $(e.target);
     selectedCity = $this.attr('id').split('-')[1];
     selectedCityName = $this.html();
     $this.closest('#vendor-register-form').find('#cityInit').text(selectedCityName) //= '';//(selectedName);
     $this.closest('#vendor-register-form').find('#cityInit').append('<i class="fa svt-arrow fa-chevron-down" style="top: 8px;"></i>');
}

function showForm(target) {
    //$('#formModal').trigger('reveal:close');
    $('#loginModal').modal('hide');
    if (target === '#forgot_panel') {
        $('#loginModal').modal('hide');
    }
    if (target === '#register_panel') {
        $('#loginModal').modal('hide');
    }
    if (target === '#vendorregister_panel') {
        $('#formModal').css('height', 'auto');
        mastersApi();
    }
    var screen_width = $(window).innerWidth();
    if (screen_width > 1400) {
        screen_width = 1400;
    }
    var screen_height = $(window).innerHeight();
    var content = $(target).html();
    $("#load_form").html(content);
    var width = $("#formModal").width();
    var height = $("#formModal").height();
    // $('#formModal').css('top',parseInt((screen_height-height)/2));
    // $('#formModal').css('left',parseInt((screen_width-width)/2));
    //$('body').css('overflow','hidden');
    $('#formModal').reveal({
        animation: 'fade', //fade, fadeAndPop, none
        animationspeed: 300, //how fast animtions are
        closeonbackgroundclick: true, //if you click background will modal close?
        dismissmodalclass: 'close-reveal-modal' //the class of a button or element that will close an open modal
    });
    $('#formModal').css('top', parseInt($(window).scrollTop() + (screen_height - height) / 2));
    $('#formModal').css('left', parseInt($(window).scrollLeft() + (screen_width - width) / 2));
    $('#formModal').on('reveal:close', function() {
        //$('body').css('overflow','visible');
    });
}
timeoutID = "";

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validateMobile(mobile) {
    var re = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    return re.test(mobile);
}

function validateUrl(url) {
    var re = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
    if (url == '' || url == null) {
        return true
    } else {
        return re.test(url)
    }
}
var SignedUpPrompt = function() {
    window.location.reload();
}
var signing_user = false;
var registerUser = function(e) {
    e.preventDefault();
    $('.usignup').attr("disabled", "disabled");
    var $form = $(e.target).parents('form');;
    var name = $form.find('#fos_user_registration_form_name').val();
    var email = $form.find('#fos_user_registration_form_email').val();
    var password = $form.find('#fos_user_registration_form_plainPassword_first').val();
    var confirm_password = $form.find('#fos_user_registration_form_plainPassword_second').val();
    var requirederrorCount = 0;
    var token = localStorage.getItem('token');
    $form.find('.signupepos').css('display', 'none');
    if (name == '') {
        $form.find('#namesignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (email == '') {
        $form.find('#emailsignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (password == '') {
        $form.find('#passsignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (confirm_password == '') {
        $form.find('#cpasssignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (requirederrorCount > 0) {
        $('.usignup').removeAttr("disabled");
        return;
    }
    if (!validateEmail(email)) {
        $form.find('#invEmailSgUp').css('display', 'block');
        $('.usignup').removeAttr("disabled");
        return;
    }
    if (password.length < 6) {
        $form.find('#passlenerror').css('display', 'block');
        $('.usignup').removeAttr("disabled");
        return;
    }
    if (password != confirm_password) {
        $form.find('#passmatcherror').css('display', 'block');
        $('.usignup').removeAttr("disabled");
        return;
    }
    if (!signing_user) {
        signing_user = true;
    }
    if (signing_user) {
        $.ajax({
            method: 'post',
            url: domain_name + "/api/v1/user/signup?version=1.1&token=" + token,
            data: {
                name: name,
                email: email,
                password: password,
                confirm_password: confirm_password,
            }
        }).done(function(data) {
            signing_user = false;
            $('.usignup').removeAttr("disabled");
            console.log('qwertyu');
            if (!data.response.status) {
                $form.find('#signupsubmitmsg').html(data.response.message);
            }
            if (data.response.status) {
                $('#formModal').trigger('reveal:close');
                $('#signupPromptModal').modal('hide');
                localStorage.setItem('logged_in', 'true');
                $('#confirmSignUp').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            }
        })
    }
}
var signing_vendor = false;
var registerVendor = function(e) {
    e.preventDefault();
    $('.vsignup').attr("disabled", "disabled");
    var $form = $(e.target).parents('form');
    var name = $form.find('#vfos_user_registration_form_name').val();
    var email = $form.find('#vfos_user_registration_form_email').val();
    var mobile = $form.find('#vfos_user_registration_form_mobile').val();
    var password = $form.find('#vfos_user_registration_form_plainPassword_first').val();
    var confirm_password = $form.find('#vfos_user_registration_form_plainPassword_second').val();
    var requirederrorCount = 0;
    var vtoken = localStorage.getItem('vtoken');
    var categoryName = selectedName;
    var cityName = selectedCityName;
    $form.find('#vsignupepos').css('display', 'none');
    caterrFlag = 0;
    cityerrFlag = 0;

    if (name == '') {
        $form.find('#vnamesignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (email == '') {
        $form.find('#vemailsignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (mobile == '') {
        $form.find('#vmobilesignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (password == '') {
        $form.find('#vpasssignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (confirm_password == '') {
        $form.find('#vcpasssignuperror').css('display', 'block');
        requirederrorCount++;
    }
    if (requirederrorCount > 0) {
        $('.vsignup').removeAttr("disabled");
        return;
    }
    if (!validateEmail(email)) {
        $form.find('#vinvEmailSgUp').css('display', 'block');
        $('.vsignup').removeAttr("disabled");
        return;
    }
    if (!validateMobile(mobile)) {
        $form.find('#vinvMobileSgUp').css('display', 'block');
        $('.vsignup').removeAttr("disabled");
        return;
    }
    if (password.length < 6) {
        $form.find('#vpasslenerror').css('display', 'block');
        $('.vsignup').removeAttr("disabled");
        return;
    }
    if (password != confirm_password) {
        $form.find('#vpassmatcherror').css('display', 'block');
        $('.vsignup').removeAttr("disabled");
        return;
    }
    if (!selectedName || selectedName == '') {
        $form.find('#vcatError').css('display', 'block');
        $('.vsignup').removeAttr("disabled");
        caterrFlag = 1;
        return;
    }
    if (!selectedCityName || selectedCityName == '') {
         $form.find('#vcityError').css('display', 'block');
         $('.vsignup').removeAttr("disabled");
         cityerrFlag = 1;
         return;
    }

    if (!signing_vendor) {
        signing_vendor = true;
    }
    if (signing_vendor) {
        $.ajax({
            method: 'post',
            url: domain_name + "/api/v1/vendor/signup?version=1.1&token=" + vtoken,
            data: {
                name: name,
                email: email,
                mobile_number: mobile,
                password: password,
                category_id: selectedCat,
                base_city: selectedCity
            }
        }).done(function(data) {
            $('.vsignup').removeAttr("disabled");
            if (!data.response.status) {
                $form.find('#signupsubmitvmsg').html('*' + data.response.message);
            } else {
                $('#formModal').trigger('reveal:close');
                localStorage.setItem('vendor_logged_in', 'true');
                $.ajax({
                    method: 'get',
                    url: domain_name + '/api/v1/vendor/dashboard?version=1.1&token=' + vtoken
                }).success(function(data) {
                    window.location.href = domain_name + '/vendor/feeds/';
                })
            }
        })
    }
}

function showSearchSuggestions(keyword) {
    timeoutID = window.setTimeout(function() {
        getSearchSuggestions(keyword).done(setList);
    }, 200);
    //vendors = getSearchSuggestions(keyword).done(setList);
    //images = getSearchSuggestions(keyword, "image");
}

function getSearchSuggestions(keyword) {
    if (keyword != '') {
        return $.ajax({
            type: "get",
            url: "/search/suggest/" + keyword,
        });
    } else {
        return $.ajax({
            type: "get",
            url: "/search/suggest",
        });
    }
}

function setList(data) {
    $('#search-results,#search-results1').html(data).removeClass('hidden');
    $('body').unbind("keydown");
    focused = null;
    focused_section = null;
    //set mouse hover
    $('#search-results .result-section ul li,#search-results1 .result-section ul li').on('mouseover', function() {
        focused = $(this);
        focused_section = focused.parents('.result-section');
        $('#search-results .result-section ul li,#search-results1 .result-section ul li').removeClass('focused');
        $(this).addClass('focused');
    });
    $('body').bind("keydown", function(e) {
        focused = $('#search-results .result-section ul li.focused, #search-results1 .result-section ul li.focused');
        focused_section = $('#search-results .result-section ul li.focused,#search-results1 .result-section ul li.focused').parents('.result-section');
        if (e.which == 38) { //up key down
            if (focused.length) {
                if (focused.prev('li').length) {
                    focused.removeClass('focused');
                    focused = focused.prev('li');
                    focused.addClass('focused');
                } else if (focused_section.prev('.result-section').length) {
                    focused.removeClass('focused');
                    focused_section = focused_section.prev('.result-section');
                    focused = focused_section.find('ul li:last');
                    focused.addClass('focused');
                } else {
                    focused.removeClass('focused');
                    focused_section = $('#search-results .result-section:last,#search-results1 .result-section:last');
                    focused = focused_section.find('ul li:last');
                    focused.addClass('focused');
                }
            } else {
                $('#search-results .result-section:last li:last,#search-results1 .result-section:last li:last').addClass('focused');
            }
        } else if (e.which == 40) { //down key down
            if (focused.length) {
                if (focused.next('li').length) {
                    focused.removeClass('focused');
                    focused = focused.next('li');
                    focused.addClass('focused');
                } else if (focused_section.next('.result-section').length) {
                    focused.removeClass('focused');
                    focused_section = focused_section.next('.result-section');
                    focused = focused_section.find('ul li:first');
                    focused.addClass('focused');
                } else {
                    focused.removeClass('focused');
                    focused_section = $('#search-results .result-section:first,#search-results1 .result-section:first');
                    focused = focused_section.find('ul li:first');
                    focused.addClass('focused');
                }
            } else {
                $('#search-results .result-section:first li:first,#search-results1 .result-section:first li:first').addClass('focused');
            }
            //stop page scroll
            e.stopPropagation();
        } else if (e.which == 13) {
            keyword = $('#search-value,#search-value1').val();
            if (keyword != null || keyword != '') {
                if (focused.length) {
                    window.location.href = focused.find('a').attr('href');
                } else {
                    // if($('#search-results .result-section:first li:first a').length){
                    // 	alert();
                    // 	$('#search-results .result-section:first li:first a').trigger('click');
                    // }else{
                    keyword = keyword.replace(/\s+/g, '-').toLowerCase();
                    window.location.href = '/search/photos/' + keyword;
                    //}
                }
                e.stopPropagation();
            } else {
                keyword = $('#search-value').val();
                window.location.href = '/search/vendors/' + keyword;
            }
        } else if (e.keyCode == 27) {
            //alert();
            $('#search-results,#search-results1').addClass('hidden');
            e.stopPropagation();
        }
    });
}

function slideThis(target) {
    $(target).slideToggle();
}
$('#search-value,#search-value1').on('focus', function() {
    if ($('#search-results,#search-results1').html() != '') {
        $('#search-results,#search-results1').removeClass('hidden');
    }
    $('#search-value,#search-value1').on('keyup paste', function(e) {
        if (e.which != 38 && e.which != 40 && e.which != 13 && e.keyCode != 27) {
            var _this = $(this);
            window.clearTimeout(timeoutID);
            keyword = $(this).val();
            if (keyword.length > 2) {
                showSearchSuggestions(keyword);
                // }else{
                $('#search-results,#search-results1').html('').addClass('hidden');
                // }
            }
        }
    });
    $("body").click(function(e) {
        if (!$(e.target).parents('#search-bar,#mobile_search_box').length) {
            $('#search-results,.mobile_search').addClass('hidden');
        }
    });
});

function logSearch(keyword, section, path) {
    $.ajax({
        type: "POST",
        url: "/log-search",
        data: {
            'keyword': keyword,
            'section': section,
            'path': path
        },
        success: function() {
            //alert("yes");
        }
    });
}
$(document).ready(function() {
    // function to close the navbar toggle when clicked outside
    $(document).click(function(event) {
        var clickover = $(event.target);
        var _opened = $(".navbar-collapse").hasClass("navbar-collapse collapse in");
        if (_opened === true && !clickover.hasClass("navbar-toggle")) {
            $("button.navbar-toggle").click();
        }
    });
    if ($("#vendors-type-list").length) {
        $("#vendors-type-list").flexisel({
            visibleItems: 14,
            animationSpeed: 700,
            autoPlay: false,
            autoPlaySpeed: 3000,
            pauseOnHover: true,
            enableResponsiveBreakpoints: true,
            responsiveBreakpoints: {
                portrait: {
                    changePoint: 480,
                    visibleItems: 3
                },
                landscape: {
                    changePoint: 640,
                    visibleItems: 5
                },
                tablet: {
                    changePoint: 1024,
                    visibleItems: 5
                }
            }
        });
    }
    var width = $(window).width();
    /*if(width < 601) {
        if($('#toggle-categories').find("ul").length) {
            $('#toggle-categories').find("ul").flexisel({
                visibleItems: 11,
                animationSpeed: 700,
                autoPlay: false,
                autoPlaySpeed: 3000,
                pauseOnHover: true,
                enableResponsiveBreakpoints: true,
                responsiveBreakpoints: {
                    portrait: {
                        changePoint: 480,
                        visibleItems: 3
                    },
                    landscape: {
                        changePoint: 640,
                        visibleItems: 5
                    },
                    tablet: {
                        changePoint: 1024,
                        visibleItems: 5
                    }
                }
            });
        }
    }*/
});
$(function() {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('#scroll-top').fadeIn();
        } else {
            $('#scroll-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    $('#scroll-top').click(function() {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
});
$(document).ready(function() {
    $('.nav-account').click(function() {
        $('.sub-nav').toggle();
    });
    if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        if (hash == 'login') {
            if ($('.usr-login-btn').length) {
                $('.usr-login-btn').click();
            }
        }
    }
});
$(document).click(function(e) {
    var container = $(".nav-account");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".sub-nav").hide();
    }
});
$("#search_mobile_nav").click(function(e) {
    //$("#mobile_search_box").toggleClass("hidden");
    $(".mobile_search").toggle();
});
var valueSelected;
var valueCurrent;
$('#rating').on('click', function(ev) {
    //ev.preventDefault();
    // alert('h');return false;
    var day = new Date().getDate();
    var month = new Date().getMonth() + 1;
    var year = new Date().getFullYear();
    var date = [year, month, day];
    valueCurrent = Date.UTC(date[0], date[1], date[2]);
    var Selected = ($('.hiredDate').val()).split('-')
    valueSelected = Date.UTC(Selected[2], Selected[1], Selected[0]);
    if (valueCurrent < valueSelected) {
        $('.dateError').css('display', 'block');
        return false;
    } else {
        $('#reviewFormAdd').submit();
        $('.dateError').css('display', 'none');
    }
});
var is_loggedin = localStorage.getItem('logged_in');
var vendor_logged_in = localStorage.getItem('vendor_logged_in');
var isLoved = 0;
var callCount = 0;
var loveCount = 0;
var reviewcheck = function() {
    if (!is_loggedin && !vendor_logged_in) {
        openLoginModal();
    } else if (is_loggedin && !vendor_logged_in) {
        return;
    } else {
        openVendorError();
    }
}
var loveThis = function(is_loved, loveCountValue, vendor_id, e) {
    if (!is_loggedin && !vendor_logged_in) {
        openLoginModal();
    } else if (is_loggedin && !vendor_logged_in) {
        var wedding_id = localStorage.getItem('wedding_id');
        if (callCount == 0) {
            isLoved = is_loved;
            loveCount = loveCountValue;
            callCount++;
        }
        if (!isLoved) {
            $.ajax({
                method: 'post',
                url: domain_name + '/api/v1/add_favorite_list?version=1.1&token=' + token,
                data: {
                    wedding_id: wedding_id,
                    content_id: vendor_id,
                    content_type: '2'
                }
            }).done(function(data) {
                $('.fa-heart').css('color', 'rgb(251, 4, 85) !important');
                loveCount = loveCount + 1;
                console.log(loveCount);
                $(e.target).closest('a').find('.vprof-count').html(loveCount);
                isLoved = true;
                console.log($(e.target).closest('a').find('.vprof-count'));
                // $('.fa-heart').css('color', 'rgb(251, 4, 85) !important');
                // $('#count').html('');
                // $('#love_button').parents('.button-box').find('.button-value').html(data);
            });
        } else {
            $.ajax({
                method: 'post',
                url: domain_name + '/api/v1/unlove?version=1.1&token=' + token,
                data: {
                    content_id: vendor_id,
                    content_type: 2,
                    wedding_id: wedding_id,
                }
            }).done(function(data) {
                $('.fa-heart').css('color', 'rgba(0, 0, 0, 0.64)');
                loveCount = loveCount - 1;
                $(e.target).closest('a').find('.vprof-count').html(loveCount);
                console.log($(e.target).closest('a').find('.vprof-count'));
                isLoved = 0;
                console.log(isLoved);
            });
        }
    } else {
        openVendorError();
    }
}

var vendorReview = function(vendor_id) {

if(is_loggedin && !vendor_logged_in) {
         $.ajax({
                method: 'get',
                url: domain_name + '/api/v1/is_vendor_reviewed?version=1.1&token=' + token + '&vendor_id='+ vendor_id
            }).done(function(data) {
                if(data.response.status) {
                    if(data.data == 1){
                        $('#reviews').hide();
                        $('#review_msg').show();
                        // $('#review-success').css('display', 'block');
                        $('#review-submit-msg').css('display', 'block');
                        $('#review-toggle-msg').css('height', '145px');
                        ga('send', 'event',{
                          'eventCategory': 'Shortlist',
                          'eventAction': 'shortlist_on_card',
                          'eventLabel': 'shortlist_icon'
                        });

                    }else{
                        $('#reviews').show();
                        $('#review_msg').hide();
                    }
                }
            });
}
}

var shortlistThis = function(e,type,vendor_id) {
    if (!is_loggedin && !vendor_logged_in) {
        openLoginModal();
    } else if (is_loggedin && !vendor_logged_in) {
    	var wedding_id = localStorage.getItem('wedding_id');
        $.ajax({
            method: 'post',
            url: domain_name + '/api/v1/add_vendor_shortlist?version=1.1&token=' + token,
            data: {
                wedding_id: wedding_id,
                vendor_id: vendor_id,
            }
        }).done(function(data) {
        	if( type != 'venue') {
            $('.shortlist-box').find('.botton-text').html('shortlisted').css('font-size', '10px').addClass('isShortlisted');
            $('.shortlist-box').find('#sketchType').css('fill', '#27AE5F');
          } else {
          	$(e.target).closest('a').find('.fa-check').css('color','#27AE5F');
            $(e.target).closest('a').find('.vProfilebox-text').html('SHORTLISTED').css('font-size','7px');
          }
        })
    } else {
        openVendorError();
    }
}

var token = localStorage.getItem('token');
var reviewHtml = $('#reviewFormAdd').html();
var submitreview = function(e, id) {
    e.preventDefault();

    $form = $(e.target).parents('form');
    var reviewtext = $form.find('textarea').val();
    var hired_date = $form.find('#hired_date').val();
    var username = $form.find('#username').val();
    var slug = $form.find('#vendor_slug').val();
    var rating = 0;
    var money = $form.find('#webmuch_vendorbundle_review_vendorBudget').val();
    $form.find('#rate-error').css('display', 'none');
    $form.find('#review-error').css('display', 'none');
    $form.find('.verify-error').css('display', 'none');
    $form.find('.fa-square').each(function(node) {
        if ($($('.fa-square')[node]).hasClass('empty')) {} else {
            rating = $($('.fa-square')[node]).attr('data-value');
        }
    });
    if (!rating) {
        $form.find('#rate-error').css('display', 'block');
        return;
    }
    if (reviewtext.length < 50) {
        $form.find('#review-error').css('display', 'block');
        return;
    }
    $.ajax({
        method: 'post',
        url: domain_name + '/api/v1/post_review?version=1.2&token=' + token,
        data: {
            star_rating: rating,
            vendor_id: vendor_id,
            review_description: reviewtext,
            hired_date: hired_date,
            vendor_budget: money
        }
    }).success(function(data) {
            var review_id = data.data.review_id;
            if($form.find('.fb_checkbox').prop('checked') == true){
                share_prompt(data.data.username+username,reviewtext,'/profile/'+slug+'/reviews/'+review_id);
            }

        if (!data.response.status && data.response.message == "Please verify your email.") {
            $('#sendEnquiryModal').modal('show');
            $('#enquiry-content').css('display', 'none');
            $('#resend-ver-enq').css('display', 'block');
            $('#sendEnquiryModal').find('.spin-loader').css('display', 'none');
            $('#sendEnquiryModal').find('.tick-sms').css('display', 'none');
            $('#resend-ver-enquiry').css('display', 'none');
            $('#resend-ver-review').css('display', 'block');
            $('#resend-ver-success').css('display', 'none');
            $('#verification-email').unbind().click(function(e) {
                e.preventDefault();
                $('#sendEnquiryModal').find('.spin-loader').css('display', 'block');
                $.ajax({
                    method: 'get',
                    url: domain_name + '/api/v1/resend_verification?version=1.2&token=' + token,
                }).done(function(data) {
                    if (data.response.status) {
                        $('#sendEnquiryModal').find('.tick-sms').css('display', 'block');
                        $('#sendEnquiryModal').find('.spin-loader').css('display', 'none');
                        window.setTimeout(function() {
                            $('#sendEnquiryModal').modal('hide');
                        }, 1000);
                    }
                })
            });
            //$form.find('.verify-error').css('display','block');
            return;
        }
        ga('send', 'event', 'review-sent', 'click', 'popup', 0);
        $form.css('display', 'none');
        $('#review-success').css('display', 'block');
        $('#review-toggle').css('height', '145px');
        // window.setTimeout(function() {
        //     $form.css('display', 'block');
        //     $('#review-toggle').css('height', 'auto');
        //     $form.find('#rating-value').find('i').addClass('empty');
        //     $form.find('#rating-display').empty();
        //     $form.find('#webmuch_vendorbundle_review_reviewDescription').val('');
        //     $('#review-success').css('display', 'none');
        // }, 5000);
    })
}
var set_this_vendor_image = function(image_id, project_id) {
    source = $('#image_' + image_id);
    $('#modal-loader').css('visibility', 'visible');
    $.ajax({
        type: "POST",
        url: "{{ url('get_modal__vendor_image_gallery_full_category') }}",
        async: true,
        data: {
            imageID: image_id,
            vendorId: vendor_id
        },
        success: function(res) {
            if (history.pushState && history.replaceState) {
                url = "/photos/" + image_id;
                history.pushState({
                    "id": image_id
                }, "new title", url);
            }
            showModal(res, source, true, true);
        }
    });
}

var set_image_modal1 = function(image_id) {
  source = $('#image_' + image_id);
  // $('#image-modal').css('visibility', 'visible');
  var token = localStorage.getItem('token');
  $.ajax({
    type: "GET",
    url: "api/v1/image/modal",
    data:"image_id="+image_id+"&token="+token+"&version=1.1&twig=1",
    cache:false,
    dataType : 'html',
    success: function(res) {
      console.log(res);
      $('.new-modal').append(res);
      var image_url = $(".image-modal-pic").attr('src').replace('%%','400');
      $(".image-modal-pic").attr('src',image_url);
      var vendor_image_url = $(".modal-pc-image").attr('src').replace('%%','400');
      $(".modal-pc-image").attr('src',vendor_image_url);
      // var similar_image_url = $(".image-pic").attr('src').replace('%%','400');
      // $(".image-pic").attr('src',similar_image_url);
      var similar_image_url;
      $( ".image-pic" ).each(function() {
        similar_image_url = $(this).css('background-image').replace('%%','400');
        $(this).css('background-image',similar_image_url);
      });

      $('#image-modal').show();
      $('<div class="modal-backdrop"></div>').appendTo(document.body);
    }
  });
//     $( document ).ready(function() {
//       $(".new-modal .close-modal-pic").on('click', 'button.alert', function() {

//   // $('.new-modal .close-modal-pic').on('click',function(){
// // alert('nid');
//         // if($('#return_path').val() != ""){
//         //   if(history.pushState && history.replaceState) {
//         //     url = $('#return_path').val();
//         //     history.pushState({"id":""}, "new title", url);
//         //   }
//         // }
//         $('#header').removeClass('hidden');
//         $('.secondHeader').removeClass('hidden');
//         $('#filter-row').removeClass('hidden');
//         $('#modal-loader').css('left','calc(50% - 25px)');
//         $('#image-modal').hide();


//         document.removeEventListener("keydown", keypressHandler, false);
//     });
// });

  // $(document).on('click','.close-modal-pic',function(){
  //   $("#image-modal").remove();
  //   $('.modal-backdrop').remove();
  // });
}
